import { render } from "./BackofficePage.vue?vue&type=template&id=87ea8c4c&scoped=true"
import script from "./BackofficePage.vue?vue&type=script&lang=js"
export * from "./BackofficePage.vue?vue&type=script&lang=js"

import "./BackofficePage.vue?vue&type=style&index=0&id=87ea8c4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ea8c4c"]])

export default __exports__